import { createRequest } from "helpers/tools";

export const trackerNotesEdit = async (tracker_id, data) => {
    return await createRequest({
        suffix: `trackers/${tracker_id}`,
        method: "post",
        payload: data,
        handleError: false,
    });
};
